<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <personal-info-card-component :personal="personal"></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" offset="4">
        <agrega-referencia-form-component :id="id"></agrega-referencia-form-component>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AgregaReferenciaFormComponent from '../../components/AgregaReferenciaFormComponent.vue'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    AgregaReferenciaFormComponent,
    PersonalInfoCardComponent,
  },

  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PERSONAL_FOTO_CUIP(this.id)
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalFotoCuip',
    }),
  },

  methods: {
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),
  },
}
</script>
